import React from 'react';

import './GenericTimeline.scss';

function GenericTimeline(props) {

    const { data } = props;

    console.log('datos pr', data);

    return (
        <>
            {
                !data &&
                <div>no hay registros</div>
            }
            {
                data &&
                <section id='timeline'>
                    <div className="timeline-wrapper">
                        {
                            data?.map(d =>
                                <div className={`timeline-card ${d.pos}`}>
                                    <div className="head">
                                        <h3> {d.title} <small>{d.small}</small></h3>
                                    </div>
                                    <div className="body">
                                        <p>{d.body}</p>
                                    </div>
                                </div>
                            )
                        }

                    </div>
                </section>
            }
        </>

    );
}

export default GenericTimeline;